/* live-bust-1777861687 */
/* cache-bust: 1777860864 */
/* coldest-drop-collections.js v20260420
   Themed Drop Collection Filter
   ─────────────────────────────
   Transforms Shopify collection pages into variant-level grids.
   Only activates on collections defined in DROP_CONFIG below.
   Each variant gets its own card with image, title, size, price, and ATC.
*/
(function() {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────────── */
  var DROP_CONFIG = {
    'baby-dinosaur': {
      colors: ['baby dinosaur'],
      heading: 'Baby Dinosaur',
      subheading: 'Baby Dinosaur — Once it’s gone it’s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'baby dinosaur': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'crochet-is-life': {
      colors: ['crochet is life'],
      heading: 'Crochet is Life',
      subheading: 'Crochet is Life — Once it’s gone it’s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'crochet is life': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'sports-drop': {
      colors: ['buzzer beater', 'pursuit of winning', 'the world stage'],
      heading: 'Sports Drop',
      subheading: 'Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      /* Per-size image overrides — keyed by normalized color, then size.
         Falls back to 'default' key if size not found. */
      imageOverrides: {
        'buzzer beater': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_Buzzer_Main.png?v=1774803592',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_Buzzer_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561'
        },
        'pursuit of winning': {
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/pursuit-of-winning-ultra-ph.jpg?v=1774831244',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/pursuit-of-winning-ultra-ph.jpg?v=1774831244'
        },
        'the world stage': {
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify.png?v=1774926734',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914'
        }
      }
    },
    /* ── Single-color collections ──────────────────────────── */
    'glossy-pink': {
      colors: ['glossy pink'],
      heading: 'Glossy Pink',
      subheading: 'The iconic Glossy Pink — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'glossy pink': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_GlossyPink_Main.png?v=1773891363',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_GlossyPink_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_GlossyPink_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_GlossyPink_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_GlossyPink_Main.png?v=1774602615',
          '6.7oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/6_7_GlossyPink_Main.png?v=1773891491',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_GlossyPink_Main.png?v=1774602561'
        }
      }
    },
    'the-world-stage': {
      colors: ['the world stage'],
      heading: 'The World Stage',
      subheading: 'The World Stage — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'the world stage': {
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify.png?v=1774926734',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914'
        }
      }
    },
    'blue-opal': {
      colors: ['blue opal'],
      heading: 'Blue Opal',
      subheading: 'Blue Opal — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,

      imageOverrides: {
        'mont sainte': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_MontSainte_Main.png?v=1774495761',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_MontSainte_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_MontSainte_Main.png?v=1774495722',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_MontSainte_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561'
        }
      }
    },
    'flirt-flower': {
      colors: ['flirt & flower'],
      heading: 'Flirt & Flower',
      subheading: 'Flirt & Flower — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'flirt & flower': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_FlirtFlower_Main.png?v=1774495783',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_FlirtFlower_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_FlirtFollow_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_FlirtFlower_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_FlirtFlower_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_FlirtFlower_Main.png?v=1774602561'
        }
      }
    },
    'love-of-music': {
      colors: ['love of music'],
      heading: 'Love of Music',
      subheading: 'Love of Music — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'love of music': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_LoveofMusic_Main.png?v=1773891382',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_LoveofMusic_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_LoveofMusic_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_LoveofMusic_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_LoveofMusic_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_LoveofMusic_Main.png?v=1774602561'
        }
      }
    },
    'water-lilies': {
      colors: ['water lilies'],
      heading: 'Water Lilies',
      subheading: 'Water Lilies — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'water lilies': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_WaterLilies_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_WaterLilies_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_WaterLilies_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__WaterLilies_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_WaterLilies_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__WaterLilies_Main.png?v=1774602561'
        }
      }
    },
    'buzzer-beater': {
      colors: ['buzzer beater'],
      heading: 'Buzzer Beater',
      subheading: 'Buzzer Beater — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'buzzer beater': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_Buzzer_Main.png?v=1774803592',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_Buzzer_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561'
        }
      }
    },
    'stealth-black': {
      colors: ['stealth black'],
      heading: 'Stealth Black',
      subheading: 'Stealth Black — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'stealth black': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_StealhBlack_24388ae5-992b-4bf9-b120-364ca0a9966d.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StealthBlack_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_StealhBlack_4b99ee77-0179-44a9-b058-e4ed15585a75.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_StealthBlack_Main.png?v=1774602561',
          '6.7oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/6_7_Stealth_Main.png?v=1773102944',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_StealthBlack_Main.png?v=1774602561'
        }
      }
    },
    'the-dragonfly': {
      colors: ['the dragonfly'],
      heading: 'The Dragonfly',
      subheading: 'The Dragonfly — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,

      imageOverrides: {
        'stung by a bee': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_StungbuaBee_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StungByaBee_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_StungByaBee_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_StungbyaBee_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561'
        }
      }
    },
    'the-marrakech': {
      colors: ['the marrakech'],
      heading: 'The Marrakech',
      subheading: 'The Marrakech — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,

      imageOverrides: {
        'clover floral': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_CloverFloral_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_CloverFloral_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_CloverFloral_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_CloverFloral_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561'
        }
      }
    },
    'starry-night': {
      colors: ['starry night'],
      heading: 'Starry Night',
      subheading: 'Starry Night — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'starry night': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StarryNight_Main.png?v=1774803592',
          'gallon': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/128_Candy_StarryNight_Main.png?v=1773102776',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StarryNight_Main.png?v=1774803592'
        }
      }
    },
    'red-luna': {
      colors: ['red luna'],
      heading: 'Red Luna',
      subheading: 'Red Luna — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'red luna': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_RedLuna_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_RedLuna_Main.png?v=1774803592',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_RedLuna_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_RedLuna_Main.png?v=1774602615'
        }
      }
    },
    'magnolia-bloom': {
      colors: ['magnolia bloom'],
      heading: 'Magnolia Bloom',
      subheading: 'Magnolia Bloom — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'magnolia bloom': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_MagnoliaBloom_Main.png?v=1774803592',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__MagnoliaBloom_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_MagnoliaBloom_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__MagnoliaBloom_Main.png?v=1774602561'
        }
      }
    },
    'xoxo': {
      colors: ['xoxo'],
      heading: 'XOXO',
      subheading: 'XOXO — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'xoxo': {
        }
      }
    },
    'love-pop': {
      colors: ['love pop'],
      heading: 'Love Pop',
      subheading: 'Love Pop — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'love pop': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_LovePop_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_LovePop_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__LovePop_Main.png?v=1773102478',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_LovePop_Main.png?v=1773102481',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__LovePop_Main.png?v=1773102478'
        }
      }
    },
    'mont-sainte': {
      colors: ['mont sainte'],
      heading: 'Mont Sainte',
      subheading: 'Mont Sainte — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'mont sainte': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_MontSainte_Main.png?v=1774495761',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_MontSainte_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_MontSainte_Main.png?v=1774495722',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_MontSainte_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561'
        }
      }
    },
    'stung-by-a-bee': {
      colors: ['stung by a bee'],
      heading: 'Stung By A Bee',
      subheading: 'Stung By A Bee — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'stung by a bee': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_StungbuaBee_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StungByaBee_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_StungByaBee_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_StungbyaBee_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561'
        }
      }
    },
    'clover-floral': {
      colors: ['clover floral'],
      heading: 'Clover Floral',
      subheading: 'Clover Floral — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'clover floral': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_CloverFloral_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_CloverFloral_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_CloverFloral_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_CloverFloral_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561'
        }
      }
    },
    'pursuit-of-winning': {
      colors: ['pursuit of winning'],
      heading: 'Pursuit of Winning',
      subheading: 'Pursuit of Winning — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'pursuit of winning': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'
        }
      }
    },
    'glowie-turtle': {
      colors: ['glowie turtle'],
      heading: 'Glowie Turtle',
      subheading: 'Glowie Turtle — Once it\'s gone it\'s gone!',
      handles: ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'glowie turtle': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'
        }
      }
    },
    'bouquet-of-sunflowers': {
      colors: ['bouquet of sunflowers'],
      heading: 'Bouquet of Sunflowers',
      subheading: 'Bouquet of Sunflowers — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'bouquet of sunflowers': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'}
      }
    },
    'glowie-butterflies': {
      colors: ['glowie butterflies'],
      heading: 'Glowie Butterflies',
      subheading: 'Glowie Butterflies — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'glowie butterflies': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'}
      }
    },
    'aura-farming': {
      colors: ['aura farming'],
      heading: 'Aura Farming',
      subheading: 'Aura Farming — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'aura farming': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'}
      }
    },
    'irises': {
      colors: ['irises'],
      heading: 'Irises',
      subheading: 'Irises — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      /* No imageOverrides: drop page uses each variant's featured_image (its main photo). */
      imageOverrides: {}
    },
    'green-dragon': {
      colors: ['green dragon'],
      heading: 'Green Dragon',
      subheading: 'Green Dragon — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      /* Force the single Green Dragon placeholder image for every size until real
         product photos exist. Replace the URL below to swap. */
      forceDefaultImage: true,
      imageOverrides: {
        'green dragon': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/green-dragon-ultra-ph_46022b41-f9fa-4772-9d82-f6a1395e03db.jpg?v=1773102242'}
      }
    },
    'mosaic-bloom': {
      colors: ['mosaic bloom'],
      heading: 'Mosaic Bloom',
      subheading: 'Mosaic Bloom — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      /* 2026-05-13 ~10pm ET: MAIN reveal images uploaded by product team for all
         5 sizes. Flipped forceDefaultImage=false and removed imageOverrides so the
         drop grid pulls each variant's featured_image directly (which is now the
         main reveal). This is the standard "live drop" state — same shape as
         green-dragon and earlier shipped drops. */
      forceDefaultImage: false
    },
    'moonlight-mermaid': {
      colors: ['moonlight mermaid'],
      heading: 'Moonlight Mermaid',
      subheading: 'Moonlight Mermaid — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      /* 2026-05-13 ~10pm ET: MAIN reveal images uploaded for 4 sizes
         (15/20/24/46oz — no 36oz Mermaid variant). Flipped to live-drop mode. */
      forceDefaultImage: false
    },
    'magical-potions': {
      colors: ['magical potions'],
      heading: 'Magical Potions',
      subheading: 'Magical Potions — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      /* Pre-reveal: forceDefaultImage=false with green-dragon placeholder.
         Will be swapped to sneak peek images Monday 2026-05-18 10pm ET
         (see Section 5b in weekly_drop_on_sundays.md). Launch 2026-05-21. */
      forceDefaultImage: true,
      imageOverrides: {}
    },
    'berry-bae': {
      colors: ['berry bae'],
      heading: 'Berry Bae',
      subheading: 'Berry Bae — Once it\'s gone it\'s gone!',
      handles: ["coldest-24oz-ultra-v8", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle"],
      singleColor: true,
      showFilters: false,
      /* Pre-reveal placeholder. Will be swapped to sneak peek Mon 2026-05-18 10pm ET. */
      forceDefaultImage: false,
      imageOverrides: {}
    },
    /* Add more single-color collections by copying the block above */
  };

  /* ── DETECT COLLECTION ─────────────────────────────────── */
  var path = window.location.pathname;
  var match = path.match(/\/collections\/([^\/\?#]+)/);
  if (!match) return;
  var handle = match[1].toLowerCase();
  var config = DROP_CONFIG[handle];
  if (!config) return;

  /* Mark the body so our CSS hides the native .product-list grid on drop pages.
     This avoids the bug where Boost (or the theme's native product-list) renders
     above the drop-grid because no Boost selector matched. */
  document.documentElement.classList.add('drop-page-active');
  if (document.body) {
    document.body.classList.add('drop-page-active');
  } else {
    document.addEventListener('DOMContentLoaded', function() { document.body.classList.add('drop-page-active'); });
  }

  var COLORS = config.colors.map(function(c) { return c.toLowerCase(); });

  /* ── CAPTURE COLLECTION DESCRIPTION FROM DOM ─────────────
     The native theme renders <div class="collection-description"> with the
     full Shopify collection.description (used by Google + meta description).
     We hide it via CSS, but read its text first so we can re-surface it
     under the drop header. Run this synchronously now if the element
     exists, and again on DOMContentLoaded as a fallback. */
  function captureCollectionDescription() {
    if (config.__capturedDesc !== undefined && config.__capturedDesc !== null) return config.__capturedDesc;
    /* Try common locations: native page-header .rte, then .collection-description,
       then any .rte inside .page-header. */
    var selectors = [
      '.page-header .rte',
      '.collection-description',
      '.page-header .reading-width'
    ];
    var text = '';
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.textContent) {
        var t = el.textContent.trim();
        if (t.length > text.length) text = t;
      }
    }
    if (!text) return null;
    config.__capturedDesc = text;
    return text;
  }
  captureCollectionDescription();
  if (!config.__capturedDesc) {
    document.addEventListener('DOMContentLoaded', captureCollectionDescription);
  }

  /* ── HELPERS ────────────────────────────────────────────── */
  function normalizeColor(name) {
    return (name || '').toLowerCase().replace(/\s*ultra\s*$/i, '').trim();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function sizeSort(a, b) {
    var order = { '6.7oz': 0, '15oz': 1, '20oz': 2, '24oz': 3, '36oz': 4, '46oz': 5, '128oz': 6, 'gallon': 7 };
    var aKey = (a.size || '').toLowerCase();
    var bKey = (b.size || '').toLowerCase();
    var aVal = order[aKey] !== undefined ? order[aKey] : 99;
    var bVal = order[bKey] !== undefined ? order[bKey] : 99;
    return aVal - bVal;
  }

  /* ── HIDE BOOST GRID + SIDEBAR ─────────────────────────── */
  var style = document.createElement('style');
  style.textContent = [
    /* Hide Boost / theme product grid until we replace it (drop-grid renders our own) */
    '.boost-sd__filter-product-list { display: none !important; }',
    '.boost-sd__toolbar-container { display: none !important; }',
    /* Coldest theme uses native .product-list for the collection grid — hide it on drop pages.
       html.drop-page-active is used because <body> may not exist when the <style> tag is inserted.
       Also hide .filter-shade (full-screen mobile-filter dimmer overlay) which can get stuck visible.
       Also hide native .pagetitle (theme renders its own H1 collection title above our drop heading). */
    'html.drop-page-active .product-list, html.drop-page-active .filters-utility-bar, html.drop-page-active .utility-bar, html.drop-page-active .filter-shade, html.drop-page-active .pagetitle, html.drop-page-active .collection-description, html.drop-page-active .page-header .rte, html.drop-page-active .page-header, body.drop-page-active .product-list, body.drop-page-active .filters-utility-bar, body.drop-page-active .utility-bar, body.drop-page-active .filter-shade, body.drop-page-active .pagetitle, body.drop-page-active .collection-description, body.drop-page-active .page-header .rte, body.drop-page-active .page-header { display: none !important; }',

    /* ── DROP GRID STYLES ──────────────────────────────────── */
    '.drop-grid-wrap { max-width: none; margin: 0 auto; padding: 0 48px 60px; }',
    '@media (max-width: 768px) { .drop-grid-wrap { padding: 0 10px 40px; } }',
    '@media (max-width: 480px) { .drop-grid-wrap { padding: 0 8px 32px; } }',
    '.drop-grid-header { text-align: center; padding: 40px 0 30px; }',
    '.drop-grid-header h1 { font-size: 48px; font-weight: 700; margin: 0 0 8px; text-transform: none; letter-spacing: normal; line-height: 1.1; }',
    '.drop-grid-header p { font-size: 16px; color: #666; margin: 0; }',
    '.drop-grid-header .drop-header-desc { font-size: 16px; color: #555; margin: 12px auto 0; max-width: 760px; line-height: 1.5; }',
    '@media (max-width: 768px) { .drop-grid-header { padding: 24px 8px 18px; } .drop-grid-header h1 { font-size: 36px; } .drop-grid-header .drop-header-desc { font-size: 14px; padding: 0 8px; } }',
    '@media (max-width: 480px) { .drop-grid-header h1 { font-size: 30px; } .drop-grid-header .drop-header-desc { font-size: 13px; } }',

    /* Color section */
    '.drop-color-section { margin-bottom: 48px; }',
    '.drop-color-title { font-size: 22px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 20px; padding-bottom: 12px; border-bottom: 2px solid #111; }',

    /* Grid */
    '.drop-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }',
    '@media (max-width: 1024px) { .drop-grid { grid-template-columns: repeat(3, 1fr); } }',
    '@media (max-width: 768px) { .drop-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; } }',
    '@media (max-width: 480px) { .drop-grid { gap: 6px; } }',

    /* Card */
    '.drop-card { background: #fff; border-radius: 8px; overflow: hidden; position: relative; transition: box-shadow 0.2s; }',
    '.drop-card:hover { box-shadow: 0 4px 20px rgba(0,0,0,0.1); }',
    '.drop-card-link { display: block; text-decoration: none; color: inherit; }',
    '.drop-card-img-wrap { position: relative; padding-bottom: 100%; background: #f5f5f5; overflow: hidden; }',
    '.drop-card-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s; }',
    '.drop-card:hover .drop-card-img { transform: scale(1.04); }',

    /* Badges */
    '.drop-card-badge { position: absolute; top: 10px; left: 10px; background: #111; color: #fff; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 4px 10px; border-radius: 3px; letter-spacing: 0.5px; z-index: 2; }',
    '.drop-card-badge--oos { background: #888; }',
    '.drop-card-badge--sale { background: #c0392b; }',
    /* Mobile: smaller, tighter badges */
    '@media (max-width: 768px) { .drop-card-badge { font-size: 9px; padding: 3px 6px; top: 6px; left: 6px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-badge { font-size: 8.5px; padding: 2px 5px; top: 5px; left: 5px; } }',

    /* Info */
    '.drop-card-info { padding: 12px 14px 6px; text-align: left; }',
    '.drop-card-title { font-size: 13px; font-weight: 600; margin: 0 0 2px; line-height: 1.3; text-align: left; }',
    '.drop-card-size { font-size: 12px; color: #888; margin: 0 0 6px; text-align: left; }',
    '.drop-card-price { font-size: 15px; font-weight: 700; margin: 0 0 4px; display: flex; align-items: center; gap: 6px; text-align: left; justify-content: flex-start; flex-wrap: wrap; }',
    /* Mobile: tighter card padding and smaller copy */
    '@media (max-width: 768px) { .drop-card-info { padding: 10px 8px 4px; } .drop-card-title { font-size: 12px; line-height: 1.25; } .drop-card-size { font-size: 11px; margin-bottom: 4px; } .drop-card-price { font-size: 13px; gap: 4px; } }',
    '@media (max-width: 480px) { .drop-card-info { padding: 8px 6px 4px; } .drop-card-title { font-size: 11.5px; } .drop-card-price { font-size: 12.5px; } }',
    /* Force Okendo star widget left-aligned (it renders centered by default) */
    '.drop-card-info [data-oke-star-rating] { display: flex !important; justify-content: flex-start !important; align-items: center; text-align: left; margin-bottom: 4px; }',
    '.drop-card-info .oke-stars, .drop-card-info .oke-sr, .drop-card-info .oke-sr-rating { justify-content: flex-start !important; text-align: left !important; }',
    '.drop-card-price--compare { font-size: 13px; font-weight: 400; color: #999; text-decoration: line-through; }',
    '.drop-card-price--sale { color: #c0392b; }',
    '@media (max-width: 768px) { .drop-card-price--compare { font-size: 11px; } }',

    /* ATC */
    '.drop-card-atc { display: block; width: calc(100% - 28px); margin: 6px 14px 14px; padding: 10px 0; background: #111; color: #fff; border: none; border-radius: 5px; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; cursor: pointer; text-align: center; transition: background 0.2s; }',
    /* Mobile: tighter ATC button + smaller text so 2-up grid breathes */
    '@media (max-width: 768px) { .drop-card-atc { width: calc(100% - 12px); margin: 4px 6px 8px; padding: 9px 0; font-size: 11px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-atc { width: calc(100% - 8px); margin: 4px 4px 6px; padding: 8px 0; font-size: 10.5px; } }',
    '.drop-card-atc:hover { background: #333; }',
    '.drop-card-atc--oos { background: #ccc; color: #666; cursor: default; }',
    '.drop-card-atc--oos:hover { background: #ccc; }',
    '.drop-card-atc--adding { background: #444; }',
    '.drop-card-atc--added { background: #27ae60; }',

    /* Drop badge (top-right) */
    '.drop-card-drop-badge { position: absolute; top: 10px; right: 10px; padding: 4px 10px; border-radius: 3px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; z-index: 2; }',
    '.drop-card-drop-badge--sneak { background: rgba(255,255,255,0.9); color: #333; }',
    '.drop-card-drop-badge--new { background: #111; color: #fff; }',
    '.drop-card-drop-badge--limited { background: rgba(255,255,255,0.9); color: #555; }',
    /* Mobile: smaller drop badge so it doesn\'t collide with the SAVE badge on the left */
    '@media (max-width: 768px) { .drop-card-drop-badge { font-size: 8.5px; padding: 3px 6px; top: 6px; right: 6px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-drop-badge { font-size: 8px; padding: 2px 5px; top: 5px; right: 5px; } }',
    '.drop-card--oos { opacity: 0.65; }',
    '.drop-card--oos .drop-card-link { pointer-events: none; cursor: default; }',
    '.drop-card--oos .drop-card-img { filter: grayscale(20%); }',

    /* Pre-drop image reveal stages — Sun/Mon = silhouette, Tue = partial, Wed pre-10pm = partial, Wed 10pm+ = full */
    '.drop-card-img-wrap { position: relative; overflow: hidden; }',
    /* Silhouette: heavy darken via overlay scrim (works regardless of image bg color) */
    '.drop-card-img-wrap--reveal::before { content: ""; position: absolute; inset: 0; pointer-events: none; z-index: 1; }',
    '.drop-card-img-wrap--silhouette::before { background: rgba(0,0,0,0.92); }',
    '.drop-card-img-wrap--partial::before { background: rgba(0,0,0,0.55); }',
    '.drop-card-img--silhouette { filter: brightness(0.15) contrast(1.4) saturate(0); }',
    '.drop-card-img--partial { filter: brightness(0.55) contrast(1.1) saturate(0.7); }',
    '.drop-card-img-wrap--reveal::after { content: attr(data-reveal-label); position: absolute; left: 0; right: 0; bottom: 16px; text-align: center; color: #fff; font-size: 12px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; pointer-events: none; text-shadow: 0 1px 3px rgba(0,0,0,0.8); z-index: 2; }',

    /* Limited Edition badge near title */
    '.drop-header-badge { display: inline-block; background: #111; color: #fff; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 4px 12px; border-radius: 3px; letter-spacing: 0.5px; margin-left: 12px; vertical-align: middle; position: relative; top: -4px; }',
    '@media (max-width: 768px) { .drop-header-badge { display: block; margin: 8px auto 0; }  }',

    /* Drop day reserve text under sold out button */
    '.drop-card-reserve { font-size: 11px; color: #c0392b; text-align: center; margin-top: 6px; font-weight: 600; }',

    /* Loading skeleton */
    '.drop-loading { text-align: center; padding: 60px 0; font-size: 14px; color: #999; }',

    /* Filter bar */
    '.drop-filters { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; margin-bottom: 28px; }',
    '.drop-filter-btn { padding: 8px 18px; border: 1.5px solid #ccc; border-radius: 20px; background: #fff; color: #333; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s; }',
    '.drop-filter-btn:hover { border-color: #111; color: #111; }',
    '.drop-filter-btn--active { background: #111; color: #fff; border-color: #111; }',
    '.drop-filter-btn--active:hover { background: #333; border-color: #333; }',

    /* Coldest Difference banner */
    '.drop-difference { max-width: none; margin: 40px auto 0; padding: 0 48px; }',
    '@media (max-width: 768px) { .drop-difference { padding: 0 16px; } }',
    '.drop-difference-inner { display: flex; align-items: center; gap: 40px; background: rgba(239,177,199,1); border-radius: 12px; padding: 40px; }',
    '@media (max-width: 768px) { .drop-difference-inner { flex-direction: column; padding: 24px; gap: 24px; } }',
    '.drop-difference-media { flex: 1; min-width: 0; }',
    '.drop-difference-media video, .drop-difference-media img { width: 100%; border-radius: 8px; }',
    '.drop-difference-text { flex: 1; min-width: 0; }',
    '.drop-difference-text h2 { font-size: 28px; font-weight: 800; margin: 0 0 14px; text-transform: uppercase; letter-spacing: 0.5px; }',
    '.drop-difference-text p { font-size: 15px; line-height: 1.6; color: #333; margin: 0 0 18px; }',
    '.drop-difference-text ul { list-style: none; padding: 0; margin: 0; }',
    '.drop-difference-text ul li { font-size: 14px; font-weight: 600; margin-bottom: 6px; }',

    /* Bundle CTA — "Buy the Entire Bundle" */
    '.drop-bundle { max-width: 1100px; margin: 48px auto 0; padding: 28px 28px; background: linear-gradient(135deg, #0a0a0a 0%, #1f1f1f 100%); color: #fff; border-radius: 14px; box-shadow: 0 12px 40px rgba(0,0,0,0.18); border: 1px solid rgba(255,255,255,0.06); text-align: left; }',
    '@media (max-width: 768px) { .drop-bundle { margin: 32px 16px 0; padding: 22px 18px; } }',
    '.drop-bundle, .drop-bundle * { text-align: left; }',
    '.drop-bundle-inner { display: flex; flex-direction: column; gap: 18px; align-items: flex-start; }',
    '@media (min-width: 768px) { .drop-bundle-inner { flex-direction: row; align-items: center; justify-content: space-between; gap: 32px; } }',
    '.drop-bundle-copy { flex: 1 1 auto; min-width: 0; text-align: left; }',
    '.drop-bundle-eyebrow-row { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin: 0 0 12px; }',
    '.drop-bundle-eyebrow { display: inline-flex; align-items: center; font-size: 11px; font-weight: 800; letter-spacing: 1.5px; text-transform: uppercase; color: #fff; background: linear-gradient(135deg, #c0392b 0%, #e74c3c 100%); padding: 5px 11px; border-radius: 4px; text-align: left; }',
    '.drop-bundle-exclusive { display: inline-flex; align-items: center; gap: 6px; font-size: 11px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; color: #0a0a0a; background: linear-gradient(135deg, #f5d76e 0%, #f6c948 50%, #d4a017 100%); padding: 5px 11px; border-radius: 4px; box-shadow: 0 0 0 1px rgba(255,255,255,0.15) inset, 0 2px 6px rgba(212,160,23,0.35); text-align: left; }',
    '.drop-bundle-exclusive::before { content: "\u2605"; font-size: 12px; line-height: 1; }',
    '.drop-bundle-gift { display: inline-flex; align-items: center; gap: 6px; font-size: 11px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; color: #fff; background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); padding: 5px 11px; border-radius: 4px; box-shadow: 0 0 0 1px rgba(255,255,255,0.12) inset, 0 2px 6px rgba(22,163,74,0.35); text-align: left; }',
    '.drop-bundle-gift::before { content: "\ud83c\udf81"; font-size: 13px; line-height: 1; }',
    '.drop-bundle-title { font-size: 24px; font-weight: 900; margin: 0 0 8px; line-height: 1.15; letter-spacing: -0.015em; color: #fff; text-align: left; }',
    '@media (min-width: 768px) { .drop-bundle-title { font-size: 30px; } }',
    '.drop-bundle-title-shipping { display: inline-block; color: #4ade80; font-weight: 800; font-size: 0.85em; margin-left: 4px; white-space: nowrap; }',
    '.drop-bundle-sub { font-size: 14px; color: #d8d8d8; margin: 0; line-height: 1.5; text-align: left; max-width: 640px; }',
    '.drop-bundle-pricing { display: flex; align-items: baseline; gap: 12px; margin: 16px 0 0; flex-wrap: wrap; justify-content: flex-start; text-align: left; }',
    '.drop-bundle-price-sale { font-size: 34px; font-weight: 900; color: #fff; line-height: 1; }',
    '.drop-bundle-price-orig { font-size: 18px; font-weight: 500; color: #888; text-decoration: line-through; line-height: 1; }',
    '.drop-bundle-savings { display: inline-block; font-size: 12px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; background: #fff; color: #111; padding: 5px 11px; border-radius: 4px; line-height: 1.2; }',
    '.drop-bundle-cta { flex-shrink: 0; align-self: flex-start; }',
    '@media (min-width: 768px) { .drop-bundle-cta { align-self: center; } }',
    '.drop-bundle-btn { display: inline-flex; align-items: center; justify-content: center; gap: 10px; padding: 17px 30px; background: #fff; color: #111; font-size: 15px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; border: none; border-radius: 10px; cursor: pointer; transition: transform 0.15s, background 0.15s, box-shadow 0.15s; min-width: 240px; box-shadow: 0 4px 16px rgba(255,255,255,0.08); }',
    '.drop-bundle-btn:hover { background: #f5f5f5; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(255,255,255,0.12); }',
    '.drop-bundle-btn:disabled { background: #555; color: #aaa; cursor: not-allowed; transform: none; box-shadow: none; }',
    '.drop-bundle-btn-arrow { font-size: 18px; line-height: 1; transition: transform 0.2s; }',
    '.drop-bundle-btn:hover .drop-bundle-btn-arrow { transform: translateX(4px); }',
    '.drop-bundle-fineprint { font-size: 11px; color: #999; margin: 14px 0 0; line-height: 1.4; text-align: left; }',
    '\n',
    /* FAQ */
    '.drop-faq { max-width: 900px; margin: 48px auto 0; padding: 0 20px 40px; }',
    '.drop-faq h2 { font-size: 24px; font-weight: 700; text-align: center; margin: 0 0 24px; }',
    '.drop-faq details { border-bottom: 1px solid #e0e0e0; }',
    '.drop-faq summary { padding: 16px 0; font-size: 15px; font-weight: 600; cursor: pointer; list-style: none; display: flex; justify-content: space-between; align-items: center; }',
    '.drop-faq summary::-webkit-details-marker { display: none; }',
    '.drop-faq summary::after { content: "+"; font-size: 20px; font-weight: 300; color: #666; transition: transform 0.2s; }',
    '.drop-faq details[open] summary::after { content: "−"; }',
    '.drop-faq details p { padding: 0 0 16px; font-size: 14px; line-height: 1.7; color: #555; margin: 0; }',
    /* Sold-out experience */
    '.drop-soldout { text-align: center; padding: 40px 0 20px; }',
    '.drop-soldout h1 { font-size: 48px; font-weight: 700; margin: 0 0 6px; line-height: 1.1; }',
    '.drop-soldout-tag { display: inline-block; background: #c0392b; color: #fff; font-size: 14px; font-weight: 700; text-transform: uppercase; padding: 6px 16px; border-radius: 4px; letter-spacing: 1px; margin-bottom: 16px; }',
    '.drop-soldout p { font-size: 16px; color: #666; margin: 0 0 24px; }',
    '.drop-soldout-form { display: flex; justify-content: center; gap: 8px; max-width: 440px; margin: 0 auto 12px; }',
    '@media (max-width: 480px) { .drop-soldout-form { flex-direction: column; } }',
    '.drop-soldout-input { flex: 1; padding: 12px 16px; border: 1.5px solid #ccc; border-radius: 6px; font-size: 14px; outline: none; }',
    '.drop-soldout-input:focus { border-color: #111; }',
    '.drop-soldout-btn { padding: 12px 28px; background: #111; color: #fff; border: none; border-radius: 6px; font-size: 14px; font-weight: 700; cursor: pointer; white-space: nowrap; }',
    '.drop-soldout-btn:hover { background: #333; }',
    '.drop-soldout-btn--done { background: #27ae60; }',
    '.drop-soldout-msg { font-size: 13px; color: #27ae60; margin: 0; }',
    '.drop-soldout-divider { max-width: 800px; margin: 32px auto 0; padding-top: 32px; border-top: 1px solid #e0e0e0; }',
    '.drop-soldout-divider h2 { font-size: 24px; font-weight: 700; text-align: center; margin: 0 0 8px; }',
    '.drop-soldout-divider p { font-size: 15px; color: #666; text-align: center; margin: 0 0 28px; }',
    '.drop-alt-section { margin-bottom: 36px; }',
    '.drop-alt-section h3 { font-size: 18px; font-weight: 700; margin: 0 0 16px; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 2px solid #111; padding-bottom: 10px; }',
  ].join('\n');
  document.head.appendChild(style);

  /* ── LOADING STATE ──────────────────────────────────────── */
  var wrapper = document.createElement('div');
  wrapper.className = 'drop-grid-wrap';
  wrapper.innerHTML = '<div class="drop-loading">Loading Sports Drop...</div>';

  /* Insert above the collection product grid so our drop-grid is visible first */
  function insertGrid() {
    /* Try in order: Boost grid, theme product-list, Shopify collection section, anything matching */
    var anchor = document.querySelector('.boost-sd__filter-product-list') ||
                 document.querySelector('.product-list') ||
                 document.querySelector('[id*="boost"]') ||
                 document.querySelector('.collection-products') ||
                 document.querySelector('#shopify-section-collection-template') ||
                 document.querySelector('[id^="shopify-section-template--"]');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrapper, anchor);
    } else {
      /* Fallback: prepend to main content (don't append — we want to be first) */
      var main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
      main.insertBefore(wrapper, main.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertGrid);
  } else {
    insertGrid();
  }

  /* ── FETCH PRODUCT DATA ─────────────────────────────────── */
  /* We read product handles from the Boost grid, then fetch .js for each */
  function getProductHandles() {
    return new Promise(function(resolve) {
      var handles = new Set();
      /* Try parsing from Boost data attributes */
      var cards = document.querySelectorAll('[data-product]');
      cards.forEach(function(el) {
        try {
          var d = JSON.parse(el.getAttribute('data-product'));
          if (d && d.handle) handles.add(d.handle);
        } catch(e) {}
      });
      /* Also try product links */
      document.querySelectorAll('a[href*="/products/"]').forEach(function(a) {
        var m = a.href.match(/\/products\/([^\/\?#]+)/);
        if (m) handles.add(m[1]);
      });
      if (handles.size > 0) {
        resolve(Array.from(handles));
      } else {
        /* Boost may render async — wait and retry */
        var attempts = 0;
        var iv = setInterval(function() {
          attempts++;
          document.querySelectorAll('[data-product]').forEach(function(el) {
            try {
              var d = JSON.parse(el.getAttribute('data-product'));
              if (d && d.handle) handles.add(d.handle);
            } catch(e) {}
          });
          document.querySelectorAll('a[href*="/products/"]').forEach(function(a) {
            var m = a.href.match(/\/products\/([^\/\?#]+)/);
            if (m) handles.add(m[1]);
          });
          if (handles.size > 0 || attempts > 30) {
            clearInterval(iv);
            resolve(Array.from(handles));
          }
        }, 300);
      }
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .catch(function() { return null; });
  }

  /* ── BUILD VARIANT CARDS ────────────────────────────────── */
  /* ── RENDER SINGLE CARD ─────────────────────────────────── */
  /* Current drop badge state — same schedule as nav badges */
  function getDropBadge() {
    var now = new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'}));
    var day = now.getDay();
    var hour = now.getHours();
    if(day === 2) return {text:'Sneak Peek', cls:'drop-card-drop-badge--sneak'};
    if(day === 3 && hour < 22) return {text:'Sneak Peek', cls:'drop-card-drop-badge--sneak'};
    if(day === 3 && hour >= 22) return {text:'New Drop', cls:'drop-card-drop-badge--new'};
    if(day >= 4 || day <= 1) return {text:'New Drop', cls:'drop-card-drop-badge--new'};
    return null;
  }

  /* CRON-MANAGED: drop names that get badges — updated by weekly cron */
  var BADGE_DROP_NAMES = ["baby dinosaur", "crochet is life", "green dragon", "mosaic bloom", "moonlight mermaid", "magical potions", "berry bae"];

  /* CRON-MANAGED: launch dates for "reserve inventory" text (ISO date string) */
  var DROP_LAUNCH_DATES = {

    'pursuit of winning': '2026-04-23',
    'aura farming': '2026-04-23',
    'glowie turtle': '2026-04-09',
    'bouquet of sunflowers': '2026-04-16',
    'glowie butterflies': '2026-04-16',
    'irises': '2026-04-30',
    'green dragon': '2026-05-04',
    'mosaic bloom': '2026-05-14',
    'moonlight mermaid': '2026-05-14',
    'magical potions': '2026-05-21',
    'berry bae': '2026-05-21',
    'crochet is life': '2026-05-28',
    'baby dinosaur': '2026-05-28'
  };

  /* Pre-drop image reveal stage — returns 'silhouette' | 'partial' | null (full image) */
  /* Schedule (per spec): Sunday & Monday = silhouette, Tuesday = partial, Wednesday <10pm = partial, Wednesday 10pm+ = full */
  /* Only applies within 6 days BEFORE the launch date (Sun-Wed of drop week) */
  /* Colors that always show their FULL real image regardless of reveal stage.
     Add a color name here (lowercase) to bypass the silhouette/partial dark scrim. */
  var ALWAYS_FULL_REVEAL = ['berry bae', 'magical potions'];

  function getRevealStage(colorLower) {
    if (ALWAYS_FULL_REVEAL.indexOf(colorLower) !== -1) return null;
    var launchStr = DROP_LAUNCH_DATES[colorLower];
    if (!launchStr) return null;
    var now = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'}));
    var launch = new Date(launchStr + 'T00:00:00');
    /* Drop day or later: full reveal */
    if (now >= launch) return null;
    var msPerDay = 86400000;
    var daysUntil = Math.ceil((launch - now) / msPerDay);
    /* Only reveal during the 6 days before drop (Sun-Wed of drop week pattern) */
    if (daysUntil > 6) return null;
    var day = now.getDay();   /* 0=Sun, 1=Mon, 2=Tue, 3=Wed */
    var hour = now.getHours();
    if (day === 0 || day === 1) return 'silhouette';
    if (day === 2) return 'partial';
    if (day === 3 && hour < 22) return 'partial';
    return null;
  }

  /* Core colors — no badge at all (not limited edition, not new drop) */
  var CORE_COLORS = ['stealth black', 'pink reflections', 'the american', 'moroccan', 'the moroccan', 'morrocan', 'the morrocan', 'rocketship alloy', 'purple nova'];

  /* Accessory pairings — backpack + paracord + boots matched by color */
  var ACCESSORY_MAP = {
    'glossy pink': {backpack:{id:47914752049384,color:'Blushberry Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716321000,color:'Glowie Pink',handle:'coldest-glowie-paracords'},boots:{id:47118635958504,color:'Matte',handle:'coldest-boots'}},
    'the world stage': {backpack:{id:47914927718632,color:'Sky Pop Blue',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716189928,color:'Glowie Sky Blue',handle:'coldest-glowie-paracords'},boots:{id:47433965404392,color:'The Coldies',handle:'coldest-boots'}},
    'blue opal': {backpack:{id:47914927718632,color:'Sky Pop Blue',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716353768,color:'Glowie Light Blue',handle:'coldest-glowie-paracords'},boots:{id:47433965240552,color:'Fly',handle:'coldest-boots'}},
    'mont sainte': {backpack:{id:47914927816936,color:'Oatmilk Cream',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716255464,color:'Glowie Light Green',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    'flirt & flower': {backpack:{id:47914752049384,color:'Blushberry Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716222696,color:'Glowie Pink + White',handle:'coldest-glowie-paracords'},boots:{id:47433965076712,color:'Glitter',handle:'coldest-boots'}},
    'love of music': {backpack:{id:47914927685864,color:'Lilac Whip Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716452072,color:'Glowie Purple',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    'water lilies': {backpack:{id:47914927882472,color:'Caramel Drizzle Green',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716255464,color:'Glowie Light Green',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    'buzzer beater': {backpack:{id:47914738843880,color:'Midnight Black',handle:'coldest-mini-backpack-bundle'},paracord:{id:44460474171624,color:'Black',handle:'coldest-paracords'},boots:{id:47433964978408,color:'Dragon',handle:'coldest-boots'}},
    'stealth black': {backpack:{id:47914738843880,color:'Midnight Black',handle:'coldest-mini-backpack-bundle'},paracord:{id:44460474171624,color:'Black',handle:'coldest-paracords'},boots:{id:47433964978408,color:'Dragon',handle:'coldest-boots'}},
    'the dragonfly': {backpack:{id:47914927882472,color:'Caramel Drizzle Green',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716288232,color:'Glowie Lemon Green + White',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    'stung by a bee': {backpack:{id:47914927849704,color:'Sunbeam Butter Yellow',handle:'coldest-mini-backpack-bundle'},paracord:{id:44539548762344,color:'Golden Crown',handle:'coldest-paracords'},boots:{id:47433964912872,color:'After Glowie',handle:'coldest-boots'}},
    'the marrakech': {backpack:{id:47914927718632,color:'Sky Pop Blue',handle:'coldest-mini-backpack-bundle'},paracord:{id:44539548762344,color:'Golden Crown',handle:'coldest-paracords'},boots:{id:47433964912872,color:'After Glowie',handle:'coldest-boots'}},
    'clover floral': {backpack:{id:47914927882472,color:'Caramel Drizzle Green',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716386536,color:'Glowie Lemon Green',handle:'coldest-glowie-paracords'},boots:{id:47433965142248,color:'Glowie Checkers',handle:'coldest-boots'}},
    'starry night': {backpack:{id:47914927718632,color:'Sky Pop Blue',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716189928,color:'Glowie Sky Blue',handle:'coldest-glowie-paracords'},boots:{id:47433965404392,color:'The Coldies',handle:'coldest-boots'}},
    'red luna': {backpack:{id:47914927751400,color:'Strawberry Snap Burgundy',handle:'coldest-mini-backpack-bundle'},paracord:{id:46700890357992,color:'SantaRed',handle:'coldest-paracords'},boots:{id:47433964978408,color:'Dragon',handle:'coldest-boots'}},
    'magnolia bloom': {backpack:{id:47914927784168,color:'Vanilla White',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716222696,color:'Glowie Pink + White',handle:'coldest-glowie-paracords'},boots:{id:47118635958504,color:'Matte',handle:'coldest-boots'}},
    'xoxo': {backpack:{id:47914752049384,color:'Blushberry Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716321000,color:'Glowie Pink',handle:'coldest-glowie-paracords'},boots:{id:47118635958504,color:'Matte',handle:'coldest-boots'}},
    'love pop': {backpack:{id:47914927685864,color:'Lilac Whip Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716321000,color:'Glowie Pink',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    'glowie turtle': {backpack:{id:47914927882472,color:'Caramel Drizzle Green',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716255464,color:'Glowie Light Green',handle:'coldest-glowie-paracords'},boots:{id:47433965142248,color:'Glowie Checkers',handle:'coldest-boots'}},
    'bouquet of sunflowers': {backpack:{id:47914927849704,color:'Sunbeam Butter Yellow',handle:'coldest-mini-backpack-bundle'},paracord:{id:44539548762344,color:'Golden Crown',handle:'coldest-paracords'},boots:{id:47433964912872,color:'After Glowie',handle:'coldest-boots'}},
    'glowie butterflies': {backpack:{id:47914927685864,color:'Lilac Whip Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716452072,color:'Glowie Purple',handle:'coldest-glowie-paracords'},boots:{id:47433965142248,color:'Glowie Checkers',handle:'coldest-boots'}},
    'aura farming': {backpack:{id:47914927685864,color:'Lilac Whip Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716452072,color:'Glowie Purple',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    'irises': {backpack:{id:47914927685864,color:'Lilac Whip Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716452072,color:'Glowie Purple',handle:'coldest-glowie-paracords'},boots:{id:47433964945640,color:'Moonlit Glowie',handle:'coldest-boots'}},
    /* Default fallback for any drop color not explicitly mapped — ensures Complete The Look always renders */
    '_default': {backpack:{id:47914738843880,color:'Midnight Black',handle:'coldest-mini-backpack-bundle'},paracord:{id:44460474171624,color:'Black',handle:'coldest-paracords'},boots:{id:47433964978408,color:'Dragon',handle:'coldest-boots'}},
      'green dragon': {backpack:{id:47914927882472,color:'Caramel Drizzle Green',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716255464,color:'Glowie Light Green',handle:'coldest-glowie-paracords'},boots:{id:47433965142248,color:'Glowie Checkers',handle:'coldest-boots'}},
      'magical potions': {backpack:{id:47914927784168,color:'Vanilla White',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716157160,color:'Glowie White',handle:'coldest-glowie-paracords'},boots:{id:47118635958504,color:'Matte',handle:'coldest-boots'}},
      'berry bae': {backpack:{id:47914752049384,color:'Blushberry Pink',handle:'coldest-mini-backpack-bundle'},paracord:{id:47176716321000,color:'Glowie Pink',handle:'coldest-glowie-paracords'},boots:{id:47118635958504,color:'Matte',handle:'coldest-boots'}},
  };

  function renderCard(item) {
    var hasSale = item.compareAtPrice && item.compareAtPrice > item.price;
    var priceClass = hasSale ? ' drop-card-price--sale' : '';
    var h = '';
    h += '<div class="drop-card' + (item.available ? '' : ' drop-card--oos') + '" data-collection="' + (item.title || '') + '">';
    /* Sale / OOS badge (top-left) */
    if (!item.available) {
      h += '<span class="drop-card-badge drop-card-badge--oos">Sold Out</span>';
    } else if (hasSale) {
      var pct = Math.round((1 - item.price / item.compareAtPrice) * 100);
      h += '<span class="drop-card-badge drop-card-badge--sale">Save ' + pct + '%</span>';
    }
    /* Drop badge (top-right) */
    var dropBadge = getDropBadge();
    var colorLower = item.color.toLowerCase();
    var isCurrentDrop = BADGE_DROP_NAMES.indexOf(colorLower) !== -1;
    var isCoreColor = CORE_COLORS.indexOf(colorLower) !== -1;
    if (isCurrentDrop && dropBadge) {
      h += '<span class="drop-card-drop-badge ' + dropBadge.cls + '">' + dropBadge.text + '</span>';
    } else if (!isCoreColor) {
      h += '<span class="drop-card-drop-badge drop-card-drop-badge--limited">Limited Edition</span>';
    }
    /* Image — reveal stages only apply when we have real variant photos.
       If forceDefaultImage is active (and we're still pre-launch), the image
       already IS a "Coming Soon" placeholder, so skip the JS-applied dark scrim
       to avoid double-treatment. Once launch passes, forceDefaultImage no longer
       fires (see effectiveForceDefault in buildGrid), and revealStage runs
       normally so we can reveal real photos. */
    var __launchStr = DROP_LAUNCH_DATES[colorLower];
    var __pastLaunch = false;
    if (__launchStr) {
      var __launchDate = new Date(__launchStr + 'T22:00:00-04:00');
      var __nowET = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'}));
      __pastLaunch = __nowET >= __launchDate;
    }
    var __forceDefaultActive = config.forceDefaultImage && !__pastLaunch;
    var revealStage = __forceDefaultActive ? null : getRevealStage(colorLower);
    var imgCls = 'drop-card-img';
    var wrapCls = 'drop-card-img-wrap';
    var wrapAttrs = '';
    if (revealStage === 'silhouette') {
      imgCls += ' drop-card-img--silhouette';
      wrapCls += ' drop-card-img-wrap--reveal drop-card-img-wrap--silhouette';
      wrapAttrs = ' data-reveal-label="Coming Soon"';
    } else if (revealStage === 'partial') {
      imgCls += ' drop-card-img--partial';
      wrapCls += ' drop-card-img-wrap--reveal drop-card-img-wrap--partial';
      wrapAttrs = ' data-reveal-label="Sneak Peek"';
    }
    h += '<a class="drop-card-link" href="' + item.productUrl + '">';
    h += '<div class="' + wrapCls + '"' + wrapAttrs + '>';
    if (item.image) {
      h += '<img class="' + imgCls + '" src="' + item.image + '" alt="' + item.color + ' ' + item.size + '" loading="lazy">';
    }
    h += '</div></a>';
    /* Info */
    h += '<div class="drop-card-info">';
    h += '<a class="drop-card-link" href="' + item.productUrl + '">';
    h += '<p class="drop-card-title">' + item.color + ' — ' + item.size + '</p>';
    h += '<div data-oke-star-rating data-oke-reviews-product-id="shopify-' + item.productId + '" style="margin-bottom:4px"></div>';
    h += '<p class="drop-card-price' + priceClass + '">';
    h += '<span>' + formatMoney(item.price) + '</span>';
    if (hasSale) h += '<span class="drop-card-price--compare">' + formatMoney(item.compareAtPrice) + '</span>';
    h += '</p></a></div>';
    /* ATC */
    if (item.available) {
      h += '<button class="drop-card-atc" data-variant-id="' + item.variantId + '">Add to Bag</button>';
    } else {
      h += '<button class="drop-card-atc drop-card-atc--oos" disabled>Sold Out</button>';
      /* Show reserve text ONLY within 7 days BEFORE the drop day — never after */
      var colorLowerReserve = item.color.toLowerCase();
      var launchDate = DROP_LAUNCH_DATES[colorLowerReserve];
      if (launchDate) {
        var launched = new Date(launchDate + 'T00:00:00');
        var now = new Date();
        var daysUntilLaunch = (launched - now) / (1000 * 60 * 60 * 24);
        if (daysUntilLaunch >= 0 && daysUntilLaunch <= 7) {
          h += '<p class="drop-card-reserve">Sold out! Second Chance Drop Day Reserve Inventory will drop Thursday at 9:45am ET.</p>';
        }
      }
    }
    h += '</div>';
    return h;
  }

  function buildGrid(products) {
    var variantsByColor = {};

    /* If forceDefaultImage is on but the launch date has already passed,
       disable it so the drop page auto-switches to real variant photos.
       Compares against DROP_LAUNCH_DATES[primaryColor]. If no launch date is
       configured, forceDefaultImage stays as-is (treated as ongoing pre-reveal). */
    var primaryColor = (COLORS[0] || '').toLowerCase();
    var launchStr = DROP_LAUNCH_DATES[primaryColor];
    var pastLaunch = false;
    if (launchStr) {
      var launchDate = new Date(launchStr + 'T22:00:00-04:00'); /* 10pm ET launch */
      var nowET = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'}));
      pastLaunch = nowET >= launchDate;
    }
    var effectiveForceDefault = config.forceDefaultImage && !pastLaunch;

    products.forEach(function(product) {
      if (!product || !product.variants) return;

      /* Find color option index — .js returns [{name,position,values}, ...] */
      var colorIdx = -1;
      var sizeIdx = -1;
      (product.options || []).forEach(function(opt, i) {
        var name = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
        if (name === 'color') colorIdx = i;
        if (name === 'size') sizeIdx = i;
      });
      if (colorIdx === -1) return;

      product.variants.forEach(function(v) {
        var colorVal = normalizeColor(v.options[colorIdx] || '');
        if (COLORS.indexOf(colorVal) === -1) return;

        var displayColor = (v.options[colorIdx] || '').replace(/\s*Ultra\s*$/i, '').trim();
        var size = sizeIdx >= 0 ? v.options[sizeIdx] : '';

        /* Find variant image — override map > variant featured_image > default override */
        var imgUrl = '';
        var overrides = (config.imageOverrides || {})[colorVal] || {};
        var sizeKey = (size || '').toLowerCase();

        if (overrides[sizeKey]) {
          imgUrl = overrides[sizeKey];
        } else if (effectiveForceDefault && overrides['default']) {
          /* Per-collection flag: skip variant featured_image entirely, always use default override.
             Auto-disabled once the launch date has passed (see effectiveForceDefault above). */
          imgUrl = overrides['default'];
        } else if (v.featured_image && v.featured_image.src) {
          /* Only use featured_image if it belongs to this variant and isn't a generic shared image */
          var fi_vids = v.featured_image.variant_ids || [];
          var isAssigned = fi_vids.length === 0 || fi_vids.indexOf(v.id) !== -1;
          var isGeneric = fi_vids.length > 5;
          if (isAssigned && !isGeneric) {
            imgUrl = v.featured_image.src;
          } else if (overrides['default']) {
            imgUrl = overrides['default'];
          }
        } else if (overrides['default']) {
          imgUrl = overrides['default'];
        }

        /* Use 600px wide image */
        if (imgUrl) {
          imgUrl = imgUrl.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_600x$1$3');
        }

        if (!variantsByColor[displayColor]) variantsByColor[displayColor] = [];
        variantsByColor[displayColor].push({
          variantId: v.id,
          productId: product.id,
          productHandle: product.handle,
          title: product.title.replace(/\s*v\d+$/i, '').replace(/COLDEST\s*/i, ''),
          color: displayColor,
          size: size,
          price: v.price,
          compareAtPrice: v.compare_at_price,
          available: v.available,
          image: imgUrl,
          productUrl: '/products/' + product.handle + '?variant=' + v.id
        });
      });
    });

    /* Deduplicate: one card per color + product (prefer Ultra variant) */
    Object.keys(variantsByColor).forEach(function(color) {
      var seen = {};
      variantsByColor[color] = variantsByColor[color].filter(function(item) {
        var key = item.productHandle + '|' + item.size;
        if (!seen[key]) { seen[key] = true; return true; }
        return false;
      });
      /* Sort: in-stock first (by size), then sold-out (by size) */
      variantsByColor[color].sort(function(a, b) {
        if (a.available && !b.available) return -1;
        if (!a.available && b.available) return 1;
        return sizeSort(a, b);
      });
      /* Backfill: cards with no image get the image from an in-stock sibling */
      var fallbackImg = '';
      variantsByColor[color].forEach(function(item) {
        if (item.available && item.image) fallbackImg = item.image;
      });
      if (!fallbackImg) {
        variantsByColor[color].forEach(function(item) {
          if (item.image) fallbackImg = item.image;
        });
      }
      if (fallbackImg) {
        variantsByColor[color].forEach(function(item) {
          if (!item.image) item.image = fallbackImg;
        });
      }
    });

    /* ── Collect all items flat for single-color mode ── */
    var allItems = [];
    Object.keys(variantsByColor).forEach(function(color) {
      variantsByColor[color].forEach(function(item) { allItems.push(item); });
    });

    /* Render */
    var html = '';
    /* Header rendered per-mode below (skipped for sold-out) */

    /* ── Single-color mode ── */
    if (config.singleColor) {
      var anyInStock = allItems.some(function(item) { return item.available; });

      if (!anyInStock) {
        /* ── SOLD OUT EXPERIENCE ─────────────────────────── */
        html += '<div class="drop-soldout">';
        html += '<span class="drop-soldout-tag">Sold Out</span>';
        html += '<h1>' + config.heading + '</h1>';
        html += '<p>This drop sold out fast. Enter your email to get notified when it restocks.</p>';
        html += '<div class="drop-soldout-form" id="drop-restock-form">';
        html += '<input class="drop-soldout-input" type="email" placeholder="Enter your email" id="drop-restock-email">';
        html += '<button class="drop-soldout-btn" id="drop-restock-btn">Notify Me</button>';
        html += '</div>';
        html += '<p class="drop-soldout-msg" id="drop-restock-msg" style="display:none"></p>';
        html += '</div>';

        /* Show 3 in-stock alternative collections */
        html += '<div class="drop-soldout-divider">';
        html += '<h2>Shop These Instead</h2>';
        html += '<p>Explore our latest drops — in stock and ready to ship.</p>';
        html += '</div>';
        html += '<div id="drop-alt-collections"></div>';

        /* Mark that we need to load alternatives */
        wrapper.setAttribute('data-soldout', 'true');
        wrapper.setAttribute('data-soldout-color', config.colors[0]);

      } else {
        /* Normal header */
        var capDesc = config.__capturedDesc || captureCollectionDescription();
        html += '<div class="drop-grid-header">';
        html += '<h1>' + config.heading + ' <span class="drop-header-badge">Limited Edition</span></h1>';
        if (capDesc) {
          html += '<p class="drop-header-desc">' + capDesc + '</p>';
        } else {
          html += '<p>' + config.subheading + '</p>';
        }
        html += '</div>';
        /* Normal in-stock grid */
        if (config.showFilters && allItems.length > 1) {
          var collections = [];
          var seenTitles = {};
          allItems.forEach(function(item) {
            if (!seenTitles[item.title]) {
              seenTitles[item.title] = true;
              collections.push(item.title);
            }
          });
          if (collections.length > 1) {
            html += '<div class="drop-filters" id="drop-filters">';
            html += '<button class="drop-filter-btn drop-filter-btn--active" data-filter="all">All Sizes</button>';
            collections.forEach(function(title) {
              html += '<button class="drop-filter-btn" data-filter="' + title + '">' + title + '</button>';
            });
            html += '</div>';
          }
        }

        html += '<div class="drop-grid" id="drop-main-grid">';
        allItems.forEach(function(item) {
          html += renderCard(item);
        });
        html += '</div>';
      }

    } else {
      /* Multi-color header */
      var capDescMulti = config.__capturedDesc || captureCollectionDescription();
      html += '<div class="drop-grid-header">';
      html += '<h1>' + config.heading + '</h1>';
      if (capDescMulti) {
        html += '<p class="drop-header-desc">' + capDescMulti + '</p>';
      } else {
        html += '<p>' + config.subheading + '</p>';
      }
      html += '</div>';
      /* ── Multi-color mode: sections per color ── */
      var colorOrder = Object.keys(variantsByColor).sort();
      colorOrder.forEach(function(color) {
        var items = variantsByColor[color];
        var anyAvailable = items.some(function(item) { return item.available; });
        if (!anyAvailable) return;
        html += '<div class="drop-color-section">';
        html += '<h2 class="drop-color-title">' + color + '</h2>';
        html += '<div class="drop-grid">';
        items.forEach(function(item) {
          html += renderCard(item);
        });

      html += '</div>'; /* /drop-grid */
      html += '</div>'; /* /drop-color-section */
    });
    } /* end if/else singleColor */

    /* ── Bundle CTA: "Buy the entire bundle" ─────────────
       Show only when 3 or more distinct in-stock variants exist on this drop.
       Threshold is per-variant (unique SKUs), not unit count. Renders directly
       below the main grid (above Complete The Look). */
    var bundleItems = allItems.filter(function(it) { return it.available && it.variantId; });
    if (bundleItems.length >= 3) {
      var bundleTotalCents = 0;
      bundleItems.forEach(function(it) {
        var price = parseInt(it.price, 10) || 0;
        bundleTotalCents += price;
      });
      var bundleDiscountCents = Math.round(bundleTotalCents * 0.10);
      var bundleSaleCents = bundleTotalCents - bundleDiscountCents;
      /* Resolve the COLLECTION handle from the URL path — e.g. /collections/irises
         maps to discount code BUNDLE-IRISES-10. Note: config.handles is the
         list of *product* handles, not the collection handle. */
      var rawHandle = '';
      if (typeof window !== 'undefined' && window.location && window.location.pathname) {
        var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        if (m) rawHandle = m[1];
      }
      var bundleHandle = (rawHandle || '').replace(/[^a-z0-9-]/gi, '').toUpperCase();
      var bundleCode = bundleHandle ? ('BUNDLE-' + bundleHandle + '-10') : 'BUNDLE-10';
      var bundleVariantIds = bundleItems.map(function(it) { return it.variantId; });

      html += '<aside class="drop-bundle" id="drop-bundle-cta" ';
      html += 'data-bundle-code="' + bundleCode + '" ';
      html += 'data-bundle-variants="' + bundleVariantIds.join(',') + '">';
      html += '<div class="drop-bundle-inner">';
      html += '<div class="drop-bundle-copy">';
      html += '<div class="drop-bundle-eyebrow-row">';
      html += '<span class="drop-bundle-eyebrow">Save an extra 10%</span>';
      html += '<span class="drop-bundle-exclusive">Coldest.com Exclusive Deal</span>';
      html += '</div>';
      html += '<h2 class="drop-bundle-title">Buy the Entire ' + config.heading + ' Bundle <span class="drop-bundle-title-shipping">+ Free Shipping!</span></h2>';
      html += '<p class="drop-bundle-sub">All ' + bundleItems.length + ' colorways &amp; sizes still in stock — collect the whole drop in one click and save an extra 10% on the entire order.</p>';
      html += '<div class="drop-bundle-pricing">';
      html += '<span class="drop-bundle-price-sale">' + formatMoney(bundleSaleCents) + '</span>';
      html += '<span class="drop-bundle-price-orig">' + formatMoney(bundleTotalCents) + '</span>';
      html += '<span class="drop-bundle-savings">You save ' + formatMoney(bundleDiscountCents) + '</span>';
      html += '</div>';
      html += '<p class="drop-bundle-fineprint">Discount auto-applies at checkout. Remove any item and the bundle discount drops off.</p>';
      html += '</div>';
      html += '<div class="drop-bundle-cta">';
      html += '<button type="button" class="drop-bundle-btn" id="drop-bundle-btn">Add Entire Bundle <span class="drop-bundle-btn-arrow">→</span></button>';
      html += '</div>';
      html += '</div>';
      html += '</aside>';
    }

    /* ── Append accessories (backpack + paracord + boots) for single-color collections ── */
    if (config.singleColor) {
      var collectionColor = config.colors[0];
      /* Fall back to default accessory pairing if this color isn't explicitly mapped */
      var acc = ACCESSORY_MAP[collectionColor] || ACCESSORY_MAP['_default'];
      if (acc) {
        html += '<div class="drop-color-section" style="margin-top:8px">';
        html += '<h2 class="drop-color-title">Complete The Look</h2>';
        html += '<div class="drop-grid" id="drop-accessories-grid">';
        html += '<div class="drop-card drop-card--accessory-placeholder" data-acc-type="backpack" data-acc-handle="' + acc.backpack.handle + '" data-acc-variant="' + acc.backpack.id + '" data-acc-color="' + acc.backpack.color + '"><div class="drop-card-img-wrap" style="background:#eee"></div><div class="drop-card-info"><p class="drop-card-title">Loading...</p></div></div>';
        html += '<div class="drop-card drop-card--accessory-placeholder" data-acc-type="paracord" data-acc-handle="' + acc.paracord.handle + '" data-acc-variant="' + acc.paracord.id + '" data-acc-color="' + acc.paracord.color + '"><div class="drop-card-img-wrap" style="background:#eee"></div><div class="drop-card-info"><p class="drop-card-title">Loading...</p></div></div>';
        if (acc.boots) { html += '<div class="drop-card drop-card--accessory-placeholder" data-acc-type="boots" data-acc-handle="' + acc.boots.handle + '" data-acc-variant="' + acc.boots.id + '" data-acc-color="' + acc.boots.color + '"><div class="drop-card-img-wrap" style="background:#eee"></div><div class="drop-card-info"><p class="drop-card-title">Loading...</p></div></div>'; }
        html += '</div></div>';
      }
    }

    /* ── Append below-grid content blocks ─────────────── */
    html += '<div class="drop-difference"><div class="drop-difference-inner">';
    html += '<div class="drop-difference-media">';
    html += '<video autoplay loop muted playsinline preload="none" style="width:100%;border-radius:8px"><source src="https://i.shgcdn.com/36612610-0645-4775-a187-109e8ca9a6a5/gif2video/-/format/webm/-/quality/lighter/" type="video/webm"><source src="https://i.shgcdn.com/36612610-0645-4775-a187-109e8ca9a6a5/gif2video/-/format/mp4/-/quality/lighter/" type="video/mp4"></video>';
    html += '</div>';
    html += '<div class="drop-difference-text">';
    html += '<h2>The Coldest Difference</h2>';
    html += '<p>It\x27s NOT just a water bottle. Our COLDEST Water bottles are designed to help you stay colder, longer\u2122. We designed our water bottles to stay cold up to 36+ to 100+ hours. They\x27re leakproof, ultra-durable, and fit everywhere. This is Your Last Bottle\u2122.</p>';
    html += '<ul>';
    html += '<li>36+ Hours Cold</li>';
    html += '<li>Leak-Proof</li>';
    html += '<li>Coldest Armor\u2122 Triple Insulation</li>';
    html += '</ul>';
    html += '</div></div></div>';

    html += '<div class="drop-faq"><h2>Frequently Asked Questions</h2>';
    var faqs = [
      ['What makes Coldest bottles different?', 'Our bottles use Coldest Armor\u2122 Triple Insulation technology, keeping drinks cold for 36+ to 100+ hours. Every bottle is 100% leak-proof (lab tested), fits standard cup holders, and comes with 3 lids included.'],
      ['How long do Coldest bottles keep drinks cold?', 'Depending on the size, our bottles keep drinks cold for 36+ to 100+ hours. We\x27ve tested against 50+ leading brands and consistently outperform them all.'],
      ['Are Coldest bottles leak-proof?', 'Yes \u2014 100% leak-proof, lab tested. Every lid is designed to seal completely so you can toss your bottle in a bag without worry.'],
      ['Do Coldest bottles fit in cup holders?', 'Yes. All sizes are designed to fit standard car, truck, and stroller cup holders.'],
      ['What sizes are available?', 'We offer 6.7oz, 15oz, 20oz, 24oz, 36oz, 46oz, and Gallon sizes across our Limitless Ultra lineup.'],
      ['Are Coldest bottles BPA-free and lead-free?', 'Yes. All Coldest bottles are verified BPA-free, lead-free, and 100% free of forever chemicals (PFAS).'],
      ['What is the warranty?', 'Every Coldest bottle comes with a Lifetime Warranty. If anything goes wrong, we\x27ll take care of it.'],
      ['Do you offer free shipping?', 'Yes \u2014 free shipping on all orders over $125.']
    ];
    faqs.forEach(function(faq) {
      html += '<details><summary>' + faq[0] + '</summary><p>' + faq[1] + '</p></details>';
    });
    html += '</div>';

    wrapper.innerHTML = html;

    /* ── BUNDLE CTA HANDLER ──────────────────────────────
       Flow:
         1. POST all variants to /cart/add.js in one call
         2. fetch('/discount/{CODE}') — Shopify sets the discount cookie on the
            response regardless of whether we follow the redirect, so the next
            cart fetch (and checkout) will include the discount
         3. Navigate to /checkout (David 2026-05-13: virtual bundles must skip
            both the MonsterCart drawer AND the /cart page — send the customer
            straight to checkout so they can complete the purchase with the
            discount already applied. Individual ATC buttons on the same page
            keep their drawer behavior; only the multi-item bundle button
            short-circuits to checkout. */
    var bundleEl = wrapper.querySelector('#drop-bundle-cta');
    var bundleBtn = wrapper.querySelector('#drop-bundle-btn');
    if (bundleEl && bundleBtn) {
      bundleBtn.addEventListener('click', function() {
        if (bundleBtn.disabled) return;
        var code = bundleEl.getAttribute('data-bundle-code') || '';
        var ids = (bundleEl.getAttribute('data-bundle-variants') || '').split(',').filter(Boolean);
        if (ids.length < 3) return; /* belt-and-suspenders */

        bundleBtn.disabled = true;
        var originalText = bundleBtn.innerHTML;
        bundleBtn.textContent = 'Adding bundle\u2026';

        var items = ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) { return r.json().then(function(b) { return { ok: r.ok, body: b }; }); })
        .then(function(res) {
          if (!res.ok) { throw new Error('Bundle add failed'); }
          /* Apply the discount cookie. The /discount/{CODE} endpoint sets a
             session cookie that survives to checkout. We use redirect:'follow'
             so the browser actually applies the Set-Cookie header (manual
             redirect mode skips it in some browsers). The redirect=/cart.js
             param makes the chase short and lightweight. */
          if (code) {
            return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), {
              method: 'GET',
              credentials: 'same-origin',
              redirect: 'follow'
            }).catch(function() { /* swallow — cookie may still be set */ });
          }
        })
        .then(function() {
          /* Re-fetch the cart so the discount totals are refreshed and any cart
             drawer that listens to /cart.js sees the new state with discount. */
          return fetch('/cart.js', { credentials: 'same-origin' }).catch(function() {});
        })
        .then(function() {
          /* Notify all cart integrations of the update before navigating, so any
             header-cart badge counters refresh on /cart load */
          try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}

          /* Show "Added" state briefly for visual feedback */
          bundleBtn.innerHTML = 'Bundle Added \u2713';

          /* Navigate straight to checkout (NOT the MonsterCart drawer, NOT /cart).
             Updated 2026-05-13 per David: virtual bundles should take the customer
             directly to checkout so the bundle discount is locked in and the
             purchase friction is minimized. */
          setTimeout(function() {
            window.location.href = '/checkout';
          }, 350);
        })
        .catch(function(err) {
          console.error('[bundle] add failed', err);
          bundleBtn.disabled = false;
          bundleBtn.innerHTML = originalText;
          alert('Sorry, we couldn\u2019t add the bundle. Please try again or add items individually.');
        });
      });
    }

    /* ── Re-init Okendo star ratings for dynamically added cards ── */
    if (window.okeWidgetApi) {
      window.okeWidgetApi.initAllWidgets();
    } else {
      /* Okendo may load after us — poll for it */
      var okeCheck = setInterval(function() {
        if (window.okeWidgetApi) {
          clearInterval(okeCheck);
          window.okeWidgetApi.initAllWidgets();
        }
      }, 500);
      setTimeout(function() { clearInterval(okeCheck); }, 10000);
    }

    /* ── FILTER HANDLERS (single-color mode) ─────────────── */
    var filterBar = wrapper.querySelector('#drop-filters');
    if (filterBar) {
      filterBar.addEventListener('click', function(e) {
        var btn = e.target.closest('.drop-filter-btn');
        if (!btn) return;
        var filter = btn.getAttribute('data-filter');
        /* Update active state */
        filterBar.querySelectorAll('.drop-filter-btn').forEach(function(b) {
          b.classList.remove('drop-filter-btn--active');
        });
        btn.classList.add('drop-filter-btn--active');
        /* Show/hide cards */
        wrapper.querySelectorAll('.drop-card').forEach(function(card) {
          if (filter === 'all') {
            card.style.display = '';
          } else {
            var cardTitle = card.getAttribute('data-collection') || '';
            card.style.display = (cardTitle === filter) ? '' : 'none';
          }
        });
      });
    }

    /* ── ATC HANDLERS ─────────────────────────────────────── */
    wrapper.querySelectorAll('.drop-card-atc[data-variant-id]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var vid = btn.getAttribute('data-variant-id');
        btn.textContent = 'Adding...';
        btn.classList.add('drop-card-atc--adding');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.textContent = 'Added ✓';
          btn.classList.remove('drop-card-atc--adding');
          btn.classList.add('drop-card-atc--added');

          /* Trigger cart drawer if MonsterCart is present */
          if (typeof window.MonsterCart !== 'undefined') {
            try { window.MonsterCart.open(); } catch(ex) {}
          }
          /* Also dispatch a cart update event for other integrations */
          document.dispatchEvent(new CustomEvent('cart:updated'));

          setTimeout(function() {
            btn.textContent = 'Add to Bag';
            btn.classList.remove('drop-card-atc--added');
          }, 2000);
        })
        .catch(function() {
          btn.textContent = 'Error — Try Again';
          btn.classList.remove('drop-card-atc--adding');
          setTimeout(function() { btn.textContent = 'Add to Bag'; }, 2000);
        });
      });
    });
  }

  /* ── Load accessory cards ───────────────────────────── */
  function loadAccessoryCards() {
    var placeholders = wrapper.querySelectorAll('.drop-card--accessory-placeholder');
    if (!placeholders.length) return;

    var handles = [];
    placeholders.forEach(function(el) {
      var h = el.getAttribute('data-acc-handle');
      if (h && handles.indexOf(h) === -1) handles.push(h);
    });

    Promise.all(handles.map(function(h) {
      return fetch('/products/' + h + '.js').then(function(r) { return r.json(); }).catch(function() { return null; });
    })).then(function(products) {
      var productMap = {};
      products.forEach(function(p) { if (p) productMap[p.handle] = p; });

      placeholders.forEach(function(el) {
        var handle = el.getAttribute('data-acc-handle');
        var variantId = parseInt(el.getAttribute('data-acc-variant'));
        var accColor = el.getAttribute('data-acc-color');
        var product = productMap[handle];
        if (!product) return;

        var variant = null;
        product.variants.forEach(function(v) { if (v.id === variantId) variant = v; });
        if (!variant) return;

        var imgUrl = '';
        if (variant.featured_image && variant.featured_image.src) {
          imgUrl = variant.featured_image.src.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_600x$1$3');
        } else if (product.featured_image) {
          imgUrl = product.featured_image;
        }

        var productUrl = '/products/' + handle + '?variant=' + variantId;
        var title = product.title.replace(/COLDEST\s*/i, '').replace(/Coldest\s*/i, '');
        var price = variant.price;
        var compareAt = variant.compare_at_price;
        var hasSale = compareAt && compareAt > price;

        var h = '';
        h += '<a class="drop-card-link" href="' + productUrl + '"><div class="drop-card-img-wrap">';
        if (imgUrl) h += '<img class="drop-card-img" src="' + imgUrl + '" alt="' + accColor + '" loading="lazy">';
        h += '</div></a>';
        h += '<div class="drop-card-info"><a class="drop-card-link" href="' + productUrl + '">';
        h += '<p class="drop-card-title">' + accColor + '</p>';
        h += '<p class="drop-card-size" style="font-size:12px;color:#888;margin:0 0 6px">' + title + '</p>';
        h += '<p class="drop-card-price' + (hasSale ? ' drop-card-price--sale' : '') + '">';
        h += '<span>' + formatMoney(price) + '</span>';
        if (hasSale) h += '<span class="drop-card-price--compare">' + formatMoney(compareAt) + '</span>';
        h += '</p></a></div>';

        if (variant.available) {
          h += '<button class="drop-card-atc" data-variant-id="' + variantId + '">Add to Bag</button>';
        } else {
          h += '<button class="drop-card-atc drop-card-atc--oos" disabled>Sold Out</button>';
        }

        el.innerHTML = h;
        el.classList.remove('drop-card--accessory-placeholder');

        /* Attach ATC handler */
        var btn = el.querySelector('.drop-card-atc[data-variant-id]');
        if (btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            var vid = btn.getAttribute('data-variant-id');
            btn.textContent = 'Adding...';
            btn.classList.add('drop-card-atc--adding');
            fetch('/cart/add.js', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({items: [{id: parseInt(vid), quantity: 1}]})
            }).then(function(r) { return r.json(); }).then(function() {
              btn.textContent = 'Added \u2713';
              btn.classList.remove('drop-card-atc--adding');
              btn.classList.add('drop-card-atc--added');
              if (typeof window.MonsterCart !== 'undefined') try { window.MonsterCart.open(); } catch(ex) {}
              document.dispatchEvent(new CustomEvent('cart:updated'));
              setTimeout(function() { btn.textContent = 'Add to Bag'; btn.classList.remove('drop-card-atc--added'); }, 2000);
            }).catch(function() {
              btn.textContent = 'Error'; btn.classList.remove('drop-card-atc--adding');
              setTimeout(function() { btn.textContent = 'Add to Bag'; }, 2000);
            });
          });
        }
      });
    });
  }

  /* ── COLOR FAMILY MAP for visually similar suggestions ── */
  var COLOR_FAMILIES = {
    'pink': ['glossy pink', 'love pop', 'xoxo', 'flirt & flower', 'magnolia bloom'],
    'blue': ['blue opal', 'starry night', 'the world stage', 'the marrakech', 'water lilies'],
    'green': ['clover floral', 'the dragonfly', 'water lilies', 'mont sainte'],
    'red': ['red luna', 'love pop', 'xoxo'],
    'yellow': ['stung by a bee', 'clover floral'],
    'purple': ['love of music', 'starry night'],
    'black': ['stealth black', 'buzzer beater'],
    'neutral': ['mont sainte', 'magnolia bloom', 'stealth black']
  };

  function getColorFamily(colorName) {
    var cl = colorName.toLowerCase();
    for (var family in COLOR_FAMILIES) {
      if (COLOR_FAMILIES[family].indexOf(cl) !== -1) return family;
    }
    return 'neutral';
  }

  /* ── Load alternative in-stock collections for sold-out page ── */
  function loadAlternativeCollections() {
    if (!wrapper.getAttribute('data-soldout')) return;
    var soldoutColor = wrapper.getAttribute('data-soldout-color');
    var family = getColorFamily(soldoutColor);
    var familyColors = COLOR_FAMILIES[family] || [];

    /* Gather all single-color configs except the sold-out one */
    var candidates = [];
    for (var h in DROP_CONFIG) {
      var cfg = DROP_CONFIG[h];
      if (!cfg.singleColor) continue;
      if (cfg.colors[0] === soldoutColor) continue;
      /* Prioritize: same family first, then BADGE_DROP_NAMES (newest), then others */
      var isSameFamily = familyColors.indexOf(cfg.colors[0]) !== -1;
      var isNewDrop = BADGE_DROP_NAMES.indexOf(cfg.colors[0]) !== -1;
      candidates.push({ handle: h, config: cfg, isSameFamily: isSameFamily, isNewDrop: isNewDrop });
    }

    /* Sort: newest drops first, then same color family, then rest */
    candidates.sort(function(a, b) {
      if (a.isNewDrop && !b.isNewDrop) return -1;
      if (!a.isNewDrop && b.isNewDrop) return 1;
      if (a.isSameFamily && !b.isSameFamily) return -1;
      if (!a.isSameFamily && b.isSameFamily) return 1;
      return 0;
    });

    /* Take the first 3 */
    var picks = candidates.slice(0, 3);

    /* For each pick, fetch product data and render a mini collection grid */
    var allHandles = picks[0] ? picks[0].config.handles : HANDLES_DEFAULT;
    var uniqueHandles = [];
    picks.forEach(function(p) {
      (p.config.handles || []).forEach(function(h) {
        if (uniqueHandles.indexOf(h) === -1) uniqueHandles.push(h);
      });
    });

    Promise.all(uniqueHandles.map(function(h) {
      return fetch('/products/' + h + '.js').then(function(r) { return r.json(); }).catch(function() { return null; });
    })).then(function(products) {
      products = products.filter(Boolean);
      var container = wrapper.querySelector('#drop-alt-collections');
      if (!container) return;

      var altHtml = '';
      picks.forEach(function(pick) {
        var cfg = pick.config;
        var colorVal = cfg.colors[0];
        var items = [];

        products.forEach(function(product) {
          var colorIdx = -1;
          var sizeIdx = -1;
          (product.options || []).forEach(function(opt, i) {
            var name = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
            if (name === 'color') colorIdx = i;
            if (name === 'size') sizeIdx = i;
          });
          if (colorIdx === -1) return;

          product.variants.forEach(function(v) {
            var vc = normalizeColor(v.options[colorIdx] || '');
            if (vc !== colorVal) return;
            if (!v.available) return;

            var displayColor = (v.options[colorIdx] || '').replace(/\s*Ultra\s*$/i, '').trim();
            var size = sizeIdx >= 0 ? v.options[sizeIdx] : '';
            var imgUrl = '';
            var overrides = (cfg.imageOverrides || {})[colorVal] || {};
            var sizeKey = (size || '').toLowerCase();
            if (overrides[sizeKey]) imgUrl = overrides[sizeKey];
            else if (v.featured_image && v.featured_image.src) {
              var fi_vids = v.featured_image.variant_ids || [];
              var isGeneric = fi_vids.length > 5;
              if (!isGeneric) imgUrl = v.featured_image.src;
            }
            if (!imgUrl && overrides['default']) imgUrl = overrides['default'];
            if (imgUrl) imgUrl = imgUrl.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_600x$1$3');

            items.push({
              variantId: v.id, productId: product.id, productHandle: product.handle,
              title: product.title.replace(/\s*v\d+$/i, '').replace(/COLDEST\s*/i, ''),
              color: displayColor, size: size, price: v.price,
              compareAtPrice: v.compare_at_price, available: true, image: imgUrl,
              productUrl: '/products/' + product.handle + '?variant=' + v.id
            });
          });
        });

        /* Backfill images */
        var bestImg = '';
        items.forEach(function(item) { if (item.image && !bestImg) bestImg = item.image; });
        if (bestImg) items.forEach(function(item) { if (!item.image) item.image = bestImg; });

        /* Dedup and sort */
        var seen = {};
        items = items.filter(function(item) {
          var key = item.productHandle + '|' + item.size;
          if (!seen[key]) { seen[key] = true; return true; }
          return false;
        });
        items.sort(sizeSort);

        if (items.length === 0) return;

        altHtml += '<div class="drop-alt-section">';
        altHtml += '<h3><a href="/collections/' + pick.handle + '" style="color:inherit;text-decoration:none">' + cfg.heading + '</a></h3>';
        altHtml += '<div class="drop-grid">';
        items.forEach(function(item) { altHtml += renderCard(item); });
        altHtml += '</div></div>';
      });

      container.innerHTML = altHtml;

      /* Attach ATC handlers for alt collection cards */
      container.querySelectorAll('.drop-card-atc[data-variant-id]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var vid = btn.getAttribute('data-variant-id');
          btn.textContent = 'Adding...';
          btn.classList.add('drop-card-atc--adding');
          fetch('/cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: parseInt(vid), quantity: 1}]})
          }).then(function(r) { return r.json(); }).then(function() {
            btn.textContent = 'Added \u2713';
            btn.classList.remove('drop-card-atc--adding');
            btn.classList.add('drop-card-atc--added');
            if (typeof window.MonsterCart !== 'undefined') try { window.MonsterCart.open(); } catch(ex) {}
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function() { btn.textContent = 'Add to Bag'; btn.classList.remove('drop-card-atc--added'); }, 2000);
          }).catch(function() {
            btn.textContent = 'Error'; btn.classList.remove('drop-card-atc--adding');
            setTimeout(function() { btn.textContent = 'Add to Bag'; }, 2000);
          });
        });
      });
    });

    /* Klaviyo email capture handler */
    var restockBtn = wrapper.querySelector('#drop-restock-btn');
    var restockInput = wrapper.querySelector('#drop-restock-email');
    var restockMsg = wrapper.querySelector('#drop-restock-msg');
    if (restockBtn && restockInput) {
      restockBtn.addEventListener('click', function() {
        var email = restockInput.value.trim();
        if (!email || email.indexOf('@') === -1) {
          restockInput.style.borderColor = '#c0392b';
          return;
        }
        restockBtn.textContent = 'Submitting...';
        /* Subscribe via Klaviyo client API */
        fetch('https://a.klaviyo.com/client/subscriptions/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Restock Notify - ' + config.heading,
                profile: { data: { type: 'profile', attributes: { email: email, properties: { restock_collection: config.heading } } } },
                channels: { email: ['MARKETING'] }
              },
              relationships: {
                list: { data: { type: 'list', id: 'PCjMSX' } }
              }
            }
          })
        }).then(function() {
          restockBtn.textContent = 'Subscribed!';
          restockBtn.classList.add('drop-soldout-btn--done');
          restockMsg.textContent = 'We\x27ll notify you when ' + config.heading + ' restocks.';
          restockMsg.style.display = 'block';
          restockInput.style.display = 'none';
        }).catch(function() {
          /* Fallback: try the older onsite API */
          fetch('https://a.klaviyo.com/api/v2/list/PCjMSX/subscribe?api_key=NBGdLy', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ profiles: [{ email: email, restock_collection: config.heading }] })
          }).then(function() {
            restockBtn.textContent = 'Subscribed!';
            restockBtn.classList.add('drop-soldout-btn--done');
            restockMsg.textContent = 'We\x27ll notify you when ' + config.heading + ' restocks.';
            restockMsg.style.display = 'block';
            restockInput.style.display = 'none';
          }).catch(function() {
            restockBtn.textContent = 'Notify Me';
          });
        });
      });
    }
  }

  var HANDLES_DEFAULT = ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'];

  /* ── INIT ───────────────────────────────────────────────── */
  /* Use pre-configured handles directly — no need to parse the DOM */
  var handles = config.handles && config.handles.length > 0
    ? config.handles
    : [];

  if (handles.length === 0) {
    /* Fallback: try to detect from Boost DOM */
    getProductHandles().then(function(detectedHandles) {
      return Promise.all(detectedHandles.map(fetchProduct));
    }).then(function(products) {
      buildGrid(products.filter(Boolean));
      setTimeout(loadAccessoryCards, 100);
      setTimeout(loadAlternativeCollections, 200);
    });
  } else {
    Promise.all(handles.map(fetchProduct)).then(function(products) {
      buildGrid(products.filter(Boolean));
      setTimeout(loadAccessoryCards, 100);
      setTimeout(loadAlternativeCollections, 200);
    });
  }

})();

/* ── Hide fully sold-out collections from nav dropdown ────── */
(function(){
  var DROP_HANDLES = ['coldest-24oz-ultra-v8','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle'];
  var NAV_COLORS = ["glossy pink", "the world stage", "blue opal", "mont sainte", "flirt & flower", "love of music", "water lilies", "buzzer beater", "stealth black", "the dragonfly", "stung by a bee", "the marrakech", "clover floral", "starry night", "red luna", "magnolia bloom", "xoxo", "love pop"];

  function checkAndHideOOS(){
    /* Only run on pages that have the nav */
    var navItems = document.querySelectorAll('.navigation__item--with-small-menu .navigation__tier-2 > .navigation__item');
    if(!navItems.length) return;

    /* For each nav color, fetch product data and check availability */
    var fetches = DROP_HANDLES.map(function(h){ return fetch('/products/' + h + '.js').then(function(r){ return r.json(); }).catch(function(){ return null; }); });

    Promise.all(fetches).then(function(products){
      products = products.filter(Boolean);

      NAV_COLORS.forEach(function(colorName){
        var colorLower = colorName.toLowerCase();
        var anyAvailable = false;

        products.forEach(function(product){
          if(!product.variants) return;
          var colorIdx = -1;
          (product.options || []).forEach(function(opt, i){
            var name = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
            if(name === 'color') colorIdx = i;
          });
          if(colorIdx === -1) return;

          product.variants.forEach(function(v){
            var vc = (v.options[colorIdx] || '').toLowerCase().replace(/\s*ultra\s*$/i, '').trim();
            if(vc === colorLower && v.available) anyAvailable = true;
          });
        });

        if(!anyAvailable){
          /* Hide this item from the nav */
          navItems.forEach(function(item){
            var link = item.querySelector('.navigation__link');
            if(!link) return;
            var text = (link.textContent || '').toLowerCase().replace(/[^a-z0-9 ]/g, '').trim();
            if(text.indexOf(colorLower) !== -1){
              item.style.display = 'none';
            }
          });
        }
      });
    });
  }

  /* Run after nav renders */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(checkAndHideOOS, 1500); });
  } else {
    setTimeout(checkAndHideOOS, 1500);
  }
})();

/* BUST 1779247332 */
/* coldest-drop-collections-v3.js — created 1779247761 to bust storefront page cache */